import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Text,
} from '@lightspeed/design-system-react'
import React, { FunctionComponent } from 'react'
import { T } from '@transifex/react'
import { $state } from '../../../../ng-compat/imports'
import { STATES } from '../../../../../../lib/routes'

interface ConfirmSaleWithGiftCardsModalProps {
  close: () => void
}

export const ConfirmSaleWithGiftCards: FunctionComponent<ConfirmSaleWithGiftCardsModalProps> = ({
  close,
}) => {
  const returnToSale = () => {
    close()
    $state.go(STATES.SALE)
  }

  return (
    <Modal onClose={close} size="small">
      <ModalHeader>
        <T _str="Hold up! You currently have a sale in progress, and it contains an unsold Gift Card" />
      </ModalHeader>
      <ModalContent>
        <Text tag="p">
          <T _str="You have a sale on the Sell screen that hasn’t been completed. As a precaution, unsold Gift Cards cannot be parked with a sale. Please return to the Sell screen to either complete that sale or remove the Gift Card to park that sale" />
        </Text>
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button onClick={returnToSale}>
            <T _str="Return to Sale in Progress" />
          </Button>
        </div>
      </ModalActions>
    </Modal>
  )
}
